import {
    isSelfReportedData,
    createLabelWithSelfReportedIcon,
} from "./selfReportedData";

/**
 * Creates a label with a self-reported icon if the metric is self-reported
 * @param label - The display label text
 * @param localLabel - The metric's local label to check if it's self-reported
 * @returns Either the plain label string or a React element with the icon
 */
export function createMetricLabel(
    label: string,
    localLabel: string | undefined,
): string | React.ReactNode {
    if (localLabel && isSelfReportedData(localLabel)) {
        return createLabelWithSelfReportedIcon(label);
    }
    return label;
}
